module.exports = __webpack_public_path__ + "static/img/banner_201903282.65bb3fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/ronganwx/img/banner_201903282.jpg
// module id = 23
// module chunks = 231